let seoData = {
    description: 'IMPACT Strategies Website Description',
    title: 'IMPACT Strategic Consulting',
    ogTitle: 'IMPACT Strategic Consulting',
    ogDescription: 'Are you ready to make an Impact?',
    ogImage: 'https://thumbsupstudio.com/static/thumbsupstudio-home-macbook-600e98c5d261de488dab03ab662e36e6.png'
}

export { seoData };
